import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { EmailRegistrationForm } from '../../../../components/EmailRegistrationForm';
import { jsx as _jsx } from "react/jsx-runtime";
export function EmailRegistrationFormContainer(_ref) {
  var isSubmitting = _ref.isSubmitting,
    login = _ref.login,
    loginError = _ref.loginError,
    isLoginInvalid = _ref.isLoginInvalid,
    hasAsyncLoginError = _ref.hasAsyncLoginError,
    password = _ref.password,
    passwordError = _ref.passwordError,
    isPasswordInvalid = _ref.isPasswordInvalid,
    hasAsyncPasswordError = _ref.hasAsyncPasswordError,
    changeLogin = _ref.changeLogin,
    changePassword = _ref.changePassword,
    register = _ref.register,
    autoFocusDisabled = _ref.autoFocusDisabled,
    isProfessionalUser = _ref.isProfessionalUser,
    source = _ref.source;
  // FORM
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    changed = _React$useState2[0],
    setChanged = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    touched = _React$useState4[0],
    setTouched = _React$useState4[1];

  // LOGIN
  var loginRef = React.useRef(null);
  var handleLoginChange = function handleLoginChange(e) {
    var value = e.currentTarget.value;
    changeLogin(value);
    setChanged(true);
  };
  React.useEffect(function () {
    if (loginRef.current) {
      loginRef.current.focus();
    }
  }, []);

  // PASSWORD
  var passwordRef = React.useRef(null);
  var handlePasswordChange = function handlePasswordChange(e) {
    var value = e.currentTarget.value;
    changePassword(value);
    setChanged(true);
  };
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    passwordShown = _React$useState6[0],
    setPasswordShown = _React$useState6[1];
  var togglePasswordVisibility = React.useCallback(function () {
    return setPasswordShown(!passwordShown);
  }, [passwordShown]);

  // SUBMITION
  var handleFocusInvalid = React.useCallback(function () {
    if (isLoginInvalid && loginRef.current) {
      loginRef.current.focus();
      return;
    }
    if (isPasswordInvalid && passwordRef.current) {
      passwordRef.current.focus();
      return;
    }
  }, [isPasswordInvalid, isLoginInvalid]);
  var handleSubmit = function handleSubmit() {
    setTouched(true);
    if (isLoginInvalid || isPasswordInvalid) {
      handleFocusInvalid();
      return;
    }
    register({
      email: login,
      password: password,
      isProfessional: isProfessionalUser,
      source: source,
      isRedesignExperimentEnabled: true
    });
    setChanged(false);
  };
  React.useEffect(function () {
    setPasswordShown(false);
    if (passwordRef.current) {
      setTouched(false);
      setChanged(false);
      passwordRef.current.focus();
    }
  }, []);
  return /*#__PURE__*/_jsx(EmailRegistrationForm, {
    handleSubmit: handleSubmit,
    isSubmitting: isSubmitting,
    autoFocusDisabled: autoFocusDisabled
    // LOGIN
    ,
    loginRef: loginRef,
    login: login,
    onLoginChange: handleLoginChange,
    loginError: !changed && loginError || undefined,
    isLoginInvalid: touched && (isLoginInvalid || !changed && hasAsyncLoginError)
    // PASSWORD
    ,
    passwordRef: passwordRef,
    password: password,
    passwordShown: passwordShown,
    isPasswordInvalid: touched && (isPasswordInvalid || !changed && hasAsyncPasswordError),
    passwordError: passwordError,
    togglePasswordVisibility: togglePasswordVisibility,
    onPasswordChange: handlePasswordChange
  });
}